/**
 * @see https://apexcharts.com/docs/vue-charts/
 */
import VueApexCharts from 'vue3-apexcharts';
export default defineNuxtPlugin((nuxt) => {
  nuxt.vueApp.use(VueApexCharts);
});
